"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Healthcare = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Healthcare = _ref => {
  let {
    color = "#13126C",
    strokeWidth = "2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    viewBox: "0 0 25 25"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    id: "Mu---FA-icons",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "2.0-Financial-Assistance",
    transform: "translate(-922.000000, -631.000000)"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Icon-/-Spot-/-Small-24-/-Cross",
    transform: "translate(923.000000, 632.000000)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    id: "bounding-box",
    fillOpacity: "0",
    fill: "#FFFFFF",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.9487179,1 L15.948,8.051 L23,8.05128205 L23,15.9487179 L15.948,15.948 L15.9487179,23 L8.05128205,23 L8.051,15.948 L1,15.9487179 L1,8.05128205 L8.051,8.051 L8.05128205,1 L15.9487179,1 Z",
    id: "Combined-Shape",
    stroke: color,
    strokeWidth: strokeWidth,
    strokeLinejoin: "round"
  })))));
};
exports.Healthcare = Healthcare;
Healthcare.displayName = "Healthcare";